import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { CardLayout, TableLayout } from '../containers/Layout';

import { fetchProducts } from '../../../../../../../jsx/actions/productAction';
import { isEmpty } from "lodash";
import Spin from '../../../../commonModules/interface/Spin';
import { TableRow, TableCell, TableHead, TableBody, TableFooter, Box } from '@material-ui/core';
import SingleTemplate from '../containers/SingleTemplate';
import PopUp from '../../../../commonModules/interface/PopUp';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class SingleSalePopUp extends Component {
    state = { 
        sale: {}
    }

    componentDidMount = () => {
        console.log("[INFO] MOUNTING SALE SINGLE POP UP");
        this.getSaleById()
        
        if (isEmpty(this.props.PRODUCTS)){
            this.props.fetchProducts()
        }
      
    }
    getSaleById = async () => {
        try {
            const req = await fetch('/stocks/single',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"sales",
                    id: this.props.saleID
                }),
                credentials: 'same-origin',
            }); 
            
            const sale = await req.json()
            console.log(sale)

            if(!sale.error && sale.id){ // no errors
                
               this.setState({sale})
            
            } else {
                
                console.log('====================================');
                console.log("ERROR getSaleById", sale);
                console.log('====================================');
            }
            
        } catch (err) {
           console.log('====================================');
           console.log("ERROR getSaleById", err);
           console.log('====================================');
        }
    }

    createProductList = () => {
        const { PRODUCTS } = this.props
        const { sale } = this.state;

        console.log({sale});
        

        return sale.products.map( saleItem => {
            let prod = PRODUCTS[saleItem.product_id]
            
            return (
                <TableRow>
                    <TableCell className="text-left">{prod.name}</TableCell>
                    <TableCell>{saleItem.quantity}</TableCell>
                    <TableCell>{formatNumbers.format(saleItem.price_ttc)}</TableCell>
                </TableRow>
            )
        })
    }
    getTotal = () => {
        let total = 0
        const { sale } = this.state
        sale.products.map( saleItem => {
            let totalTTC = parseFloat(saleItem.price_ttc) // prix vendu TTC            
            total += totalTTC
        })
        
        return [
            formatNumbers.format(total), 
        ]
    }

    render(){
        console.log("[STATE] ",this.state);
        const { sale } = this.state;
        const { PRODUCTS } = this.props;
        return(
            <PopUp 
                maxWidth="md"
                close={this.props.closeSale} title={`Vente n° ${sale.id}`}
            >
                {!isEmpty(sale) && !isEmpty(PRODUCTS) &&
                    <SingleTemplate
                        sale={sale}
                        shopID={sale.shop_id}
                        notif={this.props.notif}
                    >
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Produit</TableCell>
                                    <TableCell>Quantité</TableCell>
                                    <TableCell>Prix</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.createProductList()}
                                <TableRow>
                                    <TableCell colSpan={3}></TableCell>
                                </TableRow>
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell>TOTAL</TableCell>
                                    <TableCell>
                                        {this.getTotal()}
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                                
                        </TableLayout>     
                    </SingleTemplate>
                }
                {(isEmpty(sale) || isEmpty(PRODUCTS)) &&
                    <Spin noOverlay />
                }
                    
            </PopUp>
        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        PRODUCTS: state.inventory.products
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchProducts,
    
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleSalePopUp);
